import { SetupOverallStatus } from "../../app/models/SetupHealth";

export type SetupBannerTone = "success" | "warning" | "info";

export const getSetupHealthPresentation = (status: SetupOverallStatus) => {
    switch (status) {
        case "Ready":
            return {
                title: "Setup checks passed",
                badge: "Ready",
                tone: "success" as SetupBannerTone,
            };
        case "ActionRequired":
            return {
                title: "PartFits needs attention",
                badge: "Action required",
                tone: "warning" as SetupBannerTone,
            };
        default:
            return {
                title: "Theme setup could not be verified",
                badge: "Unable to verify",
                tone: "info" as SetupBannerTone,
            };
    }
};
